// 선행 조건(트리거) 상수.
// enum.js 는 React/antd 를 import 하므로 순수 node 로 도는 자체 점검에서 불러올 수 없다.
// 이 파일은 의존성이 없어야 하니 여기에 import 를 추가하지 말 것.
// 서버에도 같은 값이 있다 (api/services/event.js 의 OPERATION_TYPE_TRIGGER / WEEKDAY_ALL / TRIGGER_ACTION_MAX).

export const OPERATION_TYPE_TRIGGER = 5;

export const triggerTypeList = [
    {value: 1, label: '이벤트 완료'},
    {value: 2, label: '인게임 액션 달성'}
];

// 조건 사이의 결합. 첫 조건에는 적용되지 않는다.
// AND 는 우선순위 연산자가 아니라 '단계(Step) 구분자'다. AND 를 만나면 새 단계가 시작되고,
// OR 로 이어진 조건들은 같은 단계에 묶인다. 단계는 등록된 순서대로 하나씩 진행된다.
//   1 AND 2 OR 3 -> [1단계: 1] -> [2단계: 2 OR 3]
//   1 OR 2 AND 3 -> [1단계: 1 OR 2] -> [2단계: 3]
export const triggerOpList = [
    {value: 0, label: 'AND (앞 단계 완료 후 진행)', color: '#1677ff', background: '#e6f4ff'},
    {value: 1, label: 'OR (같은 단계, 하나만 달성)', color: '#389e0d', background: '#f6ffed'}
];

// triggers 에 저장된 값이므로 기존 1~4 의 숫자는 절대 바꾸지 말 것.
// isState = 누적 카운트가 아니라 '현재 보유량' 을 보는 조건.
export const triggerActionList = [
    {value: 1, label: '머지별 획득'},
    {value: 2, label: '에너지 소모'},
    {value: 3, label: '머지 미션 완료'},
    {value: 4, label: '누적 접속'},
    {value: 5, label: '머지 횟수'},
    {value: 6, label: '다이아 소모'},
    {value: 7, label: '현재 에너지 보유량 N 이상', isState: true},
    {value: 8, label: '현재 에너지 보유량 N 이하', isState: true}
];

// 발동 가능 요일. weekList 의 value(0=일 ~ 6=토)를 비트 자리로 쓰는 비트마스크다.
export const WEEKDAY_ALL = 0b1111111;          // 매일 = 127
export const WEEKDAY_WEEKDAYS = 0b0111110;     // 평일(월~금) = 62
export const WEEKDAY_WEEKEND = 0b1000001;      // 주말(토,일) = 65
export const weekdayPresetList = [
    {value: WEEKDAY_ALL, label: '매일'},
    {value: WEEKDAY_WEEKDAYS, label: '평일 전용'},
    {value: WEEKDAY_WEEKEND, label: '주말 전용'},
    {value: 0, label: '직접 지정'}
];

/**
 * 선행 조건 배열을 '단계(Step)' 로 나눈다.
 *
 * AND 는 우선순위 연산자가 아니라 단계 구분자다. AND 를 만나면 새 단계가 시작되고,
 * OR 로 이어진 조건은 같은 단계에 묶인다. 단계는 위에서부터 하나씩 진행되며,
 * 앞 단계가 완료돼야 다음 단계의 카운팅이 시작된다. 한 단계 안에서는 하나만 달성하면 통과.
 *
 *   1 AND 2 OR 3 -> [[1], [2, 3]]   (1 완료 후 -> 2 또는 3)
 *   1 OR 2 AND 3 -> [[1, 2], [3]]   (1 또는 2 완료 후 -> 3)
 *
 * 게임 서버도 반드시 같은 규칙으로 평가해야 한다.
 */
export const buildTriggerSteps = (triggers = []) => triggers.reduce((steps, trigger, i) => {
    if (i > 0 && trigger.op === 1) steps[steps.length - 1].push(trigger);
    else steps.push([trigger]);
    return steps;
}, []);
